module.exports = __webpack_public_path__ + "img/heineken.21fc3f60.png";